class PdpBarrierDropdown extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-tab-toggle]');
    this.panel = this.querySelector('[data-tab-panel]');
    this.backdrop = this.querySelector('[data-tab-backdrop]');

    if (!this.toggle || !this.panel) return;

    this.handleToggle = this.handleToggle.bind(this);
    this.close = this.close.bind(this);

    this.toggle.addEventListener('click', this.handleToggle);
    this.backdrop?.addEventListener('click', this.close);

    this.injectPrefetchRules();
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.handleToggle);
    this.backdrop?.removeEventListener('click', this.close);
  }

  handleToggle() {
    this.classList.contains('is-open') ? this.close() : this.open();
  }

  open() {
    this.classList.add('is-open');
    this.toggle.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.classList.remove('is-open');
    this.toggle.setAttribute('aria-expanded', 'false');
  }

  // Prefetch the linked product pages on hover/tap-down so switching products is
  // near-instant. Runs only because this element connected — i.e. only when the block
  // rendered. Chromium-only; other browsers ignore the rules with no regression.
  injectPrefetchRules() {
    if (!HTMLScriptElement.supports?.('speculationrules')) return;
    if (document.querySelector('script[data-barrier-repair-rules]')) return;

    const rules = {
      prefetch: [
        {
          source: 'document',
          where: { selector_matches: '[data-tab-btn]' },
          eagerness: 'moderate',
        },
      ],
    };

    const script = document.createElement('script');
    script.type = 'speculationrules';
    script.dataset.barrierRepairRules = '';
    script.textContent = JSON.stringify(rules);
    document.body.appendChild(script);
  }
}

if (!customElements.get('pdp-barrier-repair-dropdown')) {
  customElements.define('pdp-barrier-repair-dropdown', PdpBarrierDropdown);
}
